import { BaseElectionPost } from "./base/BaseElectionPost";
import {
  formatWithCommas, 
  roundToTwoDecimals, 
  convertirFecha 
} from "../utils/dataFormatter";

export class GobernadorPost extends BaseElectionPost {
  constructor() {
    super({
      electionType: 'gobernador',
      thresholds: { low: 5, medium: 25, high: 50 }
    });
  }

  /**
   * ALTERNATIVA 0: Post inicial (0-5% escrutado)
   */
  createInitialContent(data, params) {
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = this.formatProvinciaLocalidad(data.provinciaLocalidad);

    return {
      title: `Elecciones 2023: aguardando resultados para Gobernador en ${formatedProvinciaLocalidad}`,
      summary: `
        <ul>
          <li>Las urnas cerraron en ${formatedProvinciaLocalidad}.</li>
          <li>Los primeros datos del escrutinio se conocerán en las próximas horas.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "22 OCT 2023",
      lastModified: "Sun, 22 Oct 2023 19:05:00 GMT",
      gtmPublishedDate: "2023-10-22T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Las urnas cerraron en ${formatedProvinciaLocalidad} y el escrutinio provisorio para la elección a gobernador comenzó. Los primeros datos oficiales se esperan en las próximas horas a medida que avance el conteo de votos.</p>`
        },
        {
          type: "text",
          value: `<p>Esta página se actualizará automáticamente con los resultados oficiales en tiempo real una vez que comiencen a procesarse las actas de las mesas de votación.</p>`
        },
        {
          _id: "iframe-map",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: `Mapa electoral - Gobernador ${data.provincia}`,
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Resultados Gobernador ${data.provincia}" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script>
              <script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        ...this.getRelatedLinks()
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 1: Post temprano (5-25% escrutado)
   */
  createEarlyContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = this.formatProvinciaLocalidad(data.provinciaLocalidad);

    return {
      title: `Resultados Elecciones 2023 en ${formatedProvinciaLocalidad}: quién fue el candidato a gobernador más votado`,
      summary: `
        <ul>
          <li>Quién gana los comicios provinciales este domingo 22 de octubre.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Con el <strong>${data.mesasEscrutadas}</strong> por ciento de las mesas escrutadas,
            el escrutinio provisorio de las elecciones provinciales 2023 en ${formatedProvinciaLocalidad}
            determinaba que el candidato más votado a gobernador era <strong>${data.ganador.candidates[0].fullname}</strong>, 
            de <strong>${data.ganador.name}</strong>, quien sumaba <strong>${data.ganador.votes} votos</strong>,
            obteniendo el <strong>${data.ganador.votes_percent}</strong> por ciento de los votos.
          </p>`
        },
        {
          type: "text",
          value: `<p>En segundo lugar para la gobernación se encontraba 
            <strong>${data.segundo.candidates[0].fullname}</strong>, de <strong>${data.segundo.name}</strong>, que sumaba <strong>${data.segundo.votes}</strong> votos,
            logrando el <strong>${data.segundo.votes_percent}</strong> por ciento de los sufragios; mientras que en la tercera posición aparecía <strong>${data.tercero.candidates[0].fullname}</strong>, de <strong>${data.tercero.name}</strong>, 
            con <strong>${data.tercero.votes}</strong> votos (<strong>${data.tercero.votes_percent}</strong> por ciento).</p>`
        },
        {
          type: "text",
          value: `<p>En tanto, el <strong>${votosEnBlanco[0].votes_percent}%</strong> de los votos eran en blanco y un 
            <strong>${votosNulos[0].votes_percent}%</strong> (*) correspondía a votos nulos.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            Elecciones 2023: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            De cuánto es la multa por no votar</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/elecciones-2023-votos-necesitan-ganar-primera-vuelta_0_5GZaXJgLnt.html" target="_blank">
            Elecciones 2023: ¿cuántos votos se necesitan para ganar en primera vuelta?</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 2: Post parcial (25-50% escrutado)
   */
  createPartialContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = this.formatProvinciaLocalidad(data.provinciaLocalidad);

    return {
      title: `Resultados Elecciones 2023: quién fue el candidato a gobernador más votado en ${formatedProvinciaLocalidad}`,
      summary: `
        <ul>
          <li>Comicios provinciales: quién gana en esta jornada de votación.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>El escrutinio provisorio de las elecciones provinciales 2023 desarrolladas este domingo en <strong>${formatedProvinciaLocalidad}</strong> determina que el candidato 
            más votado a gobernador es <strong>${data.ganador.candidates[0].fullname}</strong>, de <strong>${data.ganador.name}</strong>, quien obtiene <strong>${data.ganador.votes}</strong> votos, 
            lo que representa el <strong>${data.ganador.votes_percent}</strong> por ciento de los votos,
            con el <strong>${data.mesasEscrutadas}</strong> por ciento de las mesas escrutadas.</p>`
        },
        {
          type: "text",
          value: `<p>En segundo lugar para la gobernación se encuentra
            <strong>${data.segundo.candidates[0].fullname}</strong>, de <strong>${data.segundo.name}</strong>, que suma
            <strong>${data.segundo.votes}</strong> votos, alcanzando el <strong>${data.segundo.votes_percent}%</strong> por
            ciento de los sufragios, mientras que en la tercera posición aparece
            <strong>${data.tercero.candidates[0].fullname}</strong>, de <strong>${data.tercero.name}</strong>,
            con <strong>${data.tercero.votes}</strong> votos (<strong>${data.tercero.votes_percent}%</strong>).</p>`
        },
        {
          type: "text",
          value: `<p>En tanto, el <strong>${votosEnBlanco[0].votes_percent}%</strong> de los votos son en blanco y un
            <strong>${votosNulos[0].votes_percent}%</strong> (*) corresponde a votos nulos.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="more-links">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            Elecciones 2023 en <strong>${formatedProvinciaLocalidad}</strong>: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            Multa por no votar: cuánto es el valor</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 3: Post final (>50% escrutado)
   */
  createFinalContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = this.formatProvinciaLocalidad(data.provinciaLocalidad);

    return {
      title: `Resultados Elecciones 2023, ${formatedProvinciaLocalidad}: quién fue el candidato a Gobernador más votado`,
      summary: `
        <ul>
          <li>Quién gana los comicios en ${formatedProvinciaLocalidad}.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>El escrutinio provisorio de las elecciones provinciales 2023 desarrolladas este domingo en <strong>${formatedProvinciaLocalidad}</strong> determina que el candidato 
            más votado a gobernador es <strong>${data.ganador.candidates[0].fullname}</strong>, de <strong>${data.ganador.name}</strong>, quien obtiene <strong>${data.ganador.votes}</strong> votos, 
            lo que representa el <strong>${data.ganador.votes_percent}</strong> por ciento de los votos,
            con el <strong>${data.mesasEscrutadas}</strong> por ciento de las mesas escrutadas.</p>`
        },
        {
          type: "text",
          value: `<p>En segundo lugar para la gobernación se encuentra <strong>${data.segundo.candidates[0].fullname}</strong>,
            de <strong>${data.segundo.name}</strong>, que logra <strong>${data.segundo.votes}</strong> votos, el <strong>${data.segundo.votes_percent}</strong> 
            por ciento de los sufragios, mientras que en la tercera posición aparece <strong>${data.tercero.candidates[0].fullname}</strong>,
            de <strong>${data.tercero.name}</strong>, con <strong>${data.segundo.votes}</strong> votos (<strong>${data.segundo.votes_percent}</strong> por ciento).</p>`
        },
        {
          type: "text",
          value: `<p>En tanto, el <strong>${votosEnBlanco[0].votes_percent}%</strong> de los votos son en blanco y un
            <strong>${votosNulos[0].votes_percent}%</strong> corresponde a votos nulos.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            ${formatedProvinciaLocalidad} | Elecciones 2023: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            Cuánto cuesta la multa por no votar</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * Helpers específicos de gobernador
   */
  formatCandidates(data) {
    const propiedades = ["ganador", "segundo", "tercero", "cuarto", "quinto"];
    propiedades.forEach(prop => {
      if (data[prop]) {
        data[prop].votes = formatWithCommas(data[prop].votes);
        data[prop].votes_percent = roundToTwoDecimals(data[prop].votes_percent);
      }
    });
    data.mesasEscrutadas = roundToTwoDecimals(data.mesasEscrutadas);
  }

  extractStats(stats, type) {
    const result = stats?.filter(item => item.type === type) || [];
    if (result[0]) {
      result[0].votes_percent = roundToTwoDecimals(result[0].votes_percent);
    }
    return result;
  }

  formatProvinciaLocalidad(cadena) {
    const partes = cadena.split(", ");
    if (partes.length === 2) {
      const [provincia, localidad] = partes;
      return `${localidad}, ${provincia}`;
    }
    return cadena;
  }

  getRelatedLinks() {
    return [
      {
        type: "text",
        value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
      },
      {
        type: "text",
        value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
          Elecciones 2023: qué pasa si no voté</a></h2>`
      },
      {
        type: "text",
        value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
          De cuánto es la multa por no votar</a></h2>`
      }
    ];
  }

  getSections() {
    return [
      {
        _id: 15006,
        name: "Información General",
        url: "informacion-general",
        nsSite: "",
        autoplay: false,
        metadata: {}
      }
    ];
  }

  getMetadata() {
    return {
      typeWeb: "small",
      origin: "default",
      payWallAccessControl: "freemium",
      sponsored: false,
      accessProduct: "CLARIN_D",
      canHaveAmp: true,
      canHaveComments: true,
      autoRefresh: true,
      titleEnable: false,
      footer_visible: true,
      ualterDisabled: false,
      trinityDisabled: false,
      disabledTimelineLiveblog: false,
      featuredContent: false,
      stopWords: true
    };
  }

  getTags(params) {
    return [
      { 
        name: `Elecciones ${params.year || 2023}`, 
        slug: `elecciones-${params.year || 2023}`, 
        subject: "subject", 
        _id: "VyFmuMo-2" 
      },
      { 
        name: "Gobernador", 
        slug: "gobernador", 
        subject: "subject" 
      }
    ];
  }

  generateMeta(content, data, params) {
    const title = content?.title || `Elecciones Gobernador ${params.year || 2023} - ${data.provincia}`;
    const description = this.extractDescription(content) || 
                       `Resultados elecciones a Gobernador en ${data.provincia}`;

    return {
      description,
      title,
      keywords: `Gobernador, ${data.provincia}, Elecciones ${params.year || 2023}, Resultados`,
      url: params.baseUrl,
      urlImage: this.getImage(params.codeLetter),
      extra: [
        { name: "title", content: title },
        { name: "distribution", content: "global" },
        { name: "robots", content: "max-image-preview:large" },
        { property: "article:published_time", content: `${params.year || 2023}-10-22T19:05:00.000Z` },
        { property: "article:modified_time", content: data.last_update }
      ]
    };
  }

  extractDescription(content) {
    return content?.description || 
           content?.body?.[0]?.value?.replace(/<[^>]*>/g, '')?.trim();
  }
}